module.exports = __webpack_public_path__ + "img/12.ca438bc6.jpg";